function _init() {
  $(".video-block-container").each(function initYoutubeVideo() {
    var $videoBlock = $(this);
    var $videoPlayer = $videoBlock.find(".video-player");
    var $videoTitle = $videoBlock.find(".video-title");

    var player = new YT.Player($videoPlayer[0].id, {
      height: "480",
      width: "640",
      videoId: $videoPlayer.data("video-id"),
      host: 'https://www.youtube-nocookie.com',
      playerVars: {
        autoplay: 0,
        enablejsapi: 1,
        modestbranding: 0,
        showinfo: 0,
        rel: 0
      },
      events: {
        onReady: function initTitle(e) {
          setTitle($videoTitle, e.target);
        }
      }
    });

    $videoBlock.on("click", ".js-click-to-play", function playVideo() {
      $videoBlock.addClass("playing");
      player.playVideo();
    });
  });
}

// Get title from video player and set it in the video title element
function setTitle($el, player) {
  $el.text(player.getVideoData().title);
}

module.exports = {
  init: _init
};
